import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { DEFAULT_TAGGING_SETTING } from '../constants';
import _ from 'lodash';
let TaggingSettingModelImpl = class TaggingSettingModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = this.defaultSetting;
    }
    get defaultSetting() {
        return _.clone(DEFAULT_TAGGING_SETTING);
    }
    get taggingSetting() {
        return this._modelData;
    }
    updateTaggingType(taggingType) {
        this.updateData({
            taggingType,
        });
    }
    updateThreshold(threshold) {
        this.updateData({
            threshold,
        });
    }
    updateReadScope(dataScope) {
        this.updateData({
            dataScope,
        });
    }
    updateAiModel(aiModel) {
        this.updateData({
            aiModel,
        });
    }
    dispose() {
        this.updateData(this.defaultSetting);
    }
    updateData(data) {
        this.update(() => {
            return {
                ...this.taggingSetting,
                ...data,
            };
        });
    }
};
TaggingSettingModelImpl = __decorate([
    injectable()
], TaggingSettingModelImpl);
export { TaggingSettingModelImpl };
